import {dateFormatToYMDHMS, strToDate} from "@/utils/time";
import {getOtherInfoByFrom} from "@/views/CustomerMessageManage/utils/getOtherInfo";
import getHistoryUsers from "@/api/chat/getHistoryUsers";

const state= {
    socket: undefined,
    //{ChatResponseMessage}
    historyMessage: JSON.parse(localStorage.getItem('historyMessage') || '[]'),
    historyMessageStr:'[]',
    msgTotal: 0,
    isPositionEnd:true,

    onlineState:false,
    onlineDisabled:false,
    autoReconnect:true,
}

const mutations = {
    SET_SOCKET(state, socket) {
        state.socket=socket
    },
    ADD_TO_HISTORY_MESSAGE(state, message) {
        // console.log('收到新消息: ',message)
        let createdTimeStr = dateFormatToYMDHMS(strToDate(message.createdTime))
        let from = message.fromType+","+message.fromId

        let userinfo = JSON.parse(localStorage.getItem('userinfo'))
        let fromType = 'agency'
        let fromId = userinfo.id

        let isMe = (message.fromType+message.fromId)===(fromType+fromId)
        let messageFromType = message.fromType
        let messageFromId = message.fromId
        if(!isMe){
            if (message.readState==='否') state.msgTotal++
        }
        getOtherInfoByFrom(messageFromType,messageFromId,isMe).then(userOtherinfo=>{
            if (isMe) {
                let origin = JSON.parse(JSON.stringify(message))
                message.fromType = origin.toType
                message.fromId = origin.toId
                message.toType = origin.fromType
                message.toId = origin.fromId
            }else{//将对方信息注入message
                message.otherinfo=userOtherinfo
            }

            const findResult = state.historyMessage.find(x =>
                (x.fromType === message.fromType && x.fromId === message.fromId) ||
                (x.fromType === message.toType && x.fromId === message.toId && x.toType === message.fromType && x.toId === message.fromId)
            )
            if (!findResult) {//如果没有记录
                if(!message.count) message.count = 0
                //如果不是自已发出的消息
                if(!isMe){
                    message.count++
                }
                //是否加载了全部消息
                message.isAll=false
                message.msgs=[{
                    from: from,
                    content:message.content,
                    contentType:message.contentType,
                    readState:message.readState,
                    createdTime:message.createdTime,
                    createdTimeStr:createdTimeStr,
                }]
                message.createdTimeStr=createdTimeStr

                //如果是自已发出的消息
                if((message.fromType+message.fromId)==(fromType+fromId) ){
                    message.fromType=message.toType
                    message.fromId=message.toId
                }

                state.historyMessage.push(message)
            }
            else {
                //如果不是自已发出的消息
                if(!isMe){
                    if(message.count){
                        findResult.count=message.count
                    }
                    else{
                        findResult.count++
                    }
                }
                if(message.createdTime<findResult.createdTime)findResult.createdTime=message.createdTime
                if (!isMe) findResult.otherinfo=message.otherinfo
                findResult.content=message.content
                findResult.contentType=message.contentType
                findResult.createdTimeStr=createdTimeStr
                findResult.msgs.push({
                    from: from,
                    content:message.content,
                    contentType:message.contentType,
                    readState:message.readState,
                    createdTime:message.createdTime,
                    createdTimeStr:createdTimeStr,
                })
                findResult.msgs.sort((a,b)=>a.createdTime-b.createdTime)
            }
            this.commit('SAVE_TO_STORAGE')
        })
    },
    SAVE_TO_STORAGE (state, isClear) {
        let historyMessageStr = JSON.stringify(state.historyMessage)
        if(historyMessageStr!=state.historyMessageStr) state.historyMessageStr=historyMessageStr
        localStorage.setItem('historyMessage', historyMessageStr)
        //计算msgTotal
        state.msgTotal = state.historyMessage.reduce((total, item) => total += item.count, 0)
        if (isClear){
            //获取联系过的用户
            let nowTime = new Date().getTime()
            let userinfo = JSON.parse(localStorage.getItem('userinfo'))
            getHistoryUsers().then(res=>{
                let data = res.data
                for (let i=0;i<data.length;i++){
                    let fromType = data[i].fromType
                    let fromId = data[i].fromId
                    getOtherInfoByFrom(fromType,fromId,false).then(info=>{
                        let historyMessage = JSON.parse(localStorage.getItem('historyMessage') || '[]')
                        let findResult = historyMessage.find(x => x.fromType===fromType && x.fromId===fromId)
                        if (!findResult){
                            let param = {
                                content: '',
                                contentType: '0',
                                count: 0,
                                createdTime: nowTime,
                                createdTimeStr: dateFormatToYMDHMS(strToDate(nowTime)),
                                fromType: fromType,
                                fromId: fromId,
                                isAll: false,
                                messageType: 2,
                                msgs: [],
                                readState: '是',
                                toType: 'agency',
                                toId: userinfo.id,
                                otherinfo: info,
                            }
                            state.historyMessage.push(param)
                            let historyMessageStr = JSON.stringify(state.historyMessage)
                            if(historyMessageStr!=state.historyMessageStr) state.historyMessageStr=historyMessageStr
                            localStorage.setItem('historyMessage', historyMessageStr)
                        }
                    })
                }
            })
        }
    },
    CLEAR_HISTORY_MESSAGE(state){
        state.msgTotal=0
        let historyMessage = state.historyMessage
        let nowTime = new Date().getTime()
        for (let i=0;i<historyMessage.length;i++){
            historyMessage[i].count = 0
            historyMessage[i].isAll = false
            historyMessage[i].createdTime = nowTime
            historyMessage[i].msgs = []
        }
        this.commit('SAVE_TO_STORAGE',true)
    },
    CLOSE_POSITION_END(state){
        state.isPositionEnd=false
    },
    OPEN_POSITION_END(state){
        state.isPositionEnd=true
    },
    SET_ONLINE_STATE(state,onlineState){
        state.onlineState=onlineState
    },
    SET_ONLINE_DISABLED(state,onlineDisabled){
        state.onlineDisabled=onlineDisabled
    },
    SET_AUTO_RECONNECT(state, autoReconnect) {
        state.autoReconnect = autoReconnect
    },
}
const actions = {
    setSocket({commit}, socket) {
        commit('SET_SOCKET', socket);
    },
    addToHistoryMessage({commit}, message) {
        commit('ADD_TO_HISTORY_MESSAGE', message);
    },
    save_to_storage({commit}) {
        commit('SAVE_TO_STORAGE');
    },
    clearHistoryMessage({commit}){
        commit('CLEAR_HISTORY_MESSAGE',);
    },
    closePositionEnd({commit}){
        commit('CLOSE_POSITION_END',);
    },
    openPositionEnd({commit}){
        commit('OPEN_POSITION_END',);
    },
    setOnlineState({commit},onlineState){
        commit('SET_ONLINE_STATE',onlineState);
    },
    setOnlineDisabled({commit},onlineDisabled){
        commit('SET_ONLINE_DISABLED',onlineDisabled);
    },
    setAutoReconnect({commit}, autoReconnect) {
        commit('SET_AUTO_RECONNECT', autoReconnect);
    },
}
export default {
    namespace: true,
    state,
    mutations,
    actions,
}